import React from 'react'
import { PlanDetailCard, PricingSummaryCard } from '@nile/components/src/Cards'
import { withRouter } from 'react-router-dom'
import { BoxContainer, RoleBoxContainer } from '@nile/banyan/src/Utils/style'
import styled from 'styled-components'

const BoxContainerWrapper = styled.div`
  width: 100%;
  .cascadeContainer {
    overflow: auto;
    &:first-child {
      background: #f1f8ff !important;
    }
    &:last-child {
      width: 100%;
      overflow: auto;
      background: white !important;
    }
  }
  .plr-15 {
    padding: 0 15px;
  }
  .bshadow {
    min-height: 40vh;
    height: calc(100vh - 230px);
  }
  .name {
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #ff1462;
    margin-bottom: 6px;
  }
  .excerpt {
    font-family: Poppins, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    color: #4d4d4d;
  }
  .line {
    width: 88px;
    height: 2px;
    border-top: 2px solid #f05;
    margin: 10px 0;
  }
  .pricing-plans-content-wrap {
    min-height: 206px;
  }
  .feature-parent {
    margin-top: 48px;
    margin-bottom: 24px;
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 30px;
    color: #170426;
  }
  .feature {
    margin-bottom: 8px;
    font-family: Poppins, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #4d4d4d;
    position: relative;
  }
  .back-btn {
    cursor: pointer;
  }
  .payment-holder {
    justify-content: flex-end;
    display: flex;
  }
`

const PricingContainer = (props) => {
  const {
    selectedPlan,
    tenure,
    setTenure,
    handleManageModal,
    setSelectedPlan,
    allFeatures,
    planFeatures,
    subscriptionTypes,
    currency,
    locale,
    isNew
  } = props

  return (
    <div className='flex jctr fh'>
      <BoxContainerWrapper className='fh'>
        <BoxContainer className='fx fh'>
          <RoleBoxContainer className='fx cascadeContainer'>
            <PlanDetailCard
              selectedPlan={selectedPlan}
              setSelectedPlan={setSelectedPlan}
              allFeatures={allFeatures}
              planFeatures={planFeatures}
              isNew={isNew}
              subscriptionTypes={subscriptionTypes}
            />
          </RoleBoxContainer>

          <RoleBoxContainer className='fx fh cascadeContainer'>
            <PricingSummaryCard
              tenure={tenure}
              setTenure={setTenure}
              selectedPlan={selectedPlan}
              handleManageModal={handleManageModal}
              currency={currency}
              locale={locale}
            />
          </RoleBoxContainer>
        </BoxContainer>
      </BoxContainerWrapper>
    </div>
  )
}

export default withRouter(PricingContainer)
